import Animation from './animation'
import * as d3 from 'd3-selection'
import { interpolate } from 'd3-interpolate'
import * as shape from 'd3-shape'

/*
 * Used when a breakdown is applied to a line. All new points in the
 * range extend from the current point.
 */
class AddBreakdownAnimation extends Animation {

  match (serie) {
    if (!this.previous.scalers.x || this.seriesChanged) {
      // We don't have previous data or series changed, so we're not sliding
      return false
    }

    return this.chart.previous.layout.breakdown.calculated && // Previously calculated
           !this.chart.layout.breakdown.calculated  // Now we're not calculated
  }

  animate (serie, entering, selection, merged, exiting) {
    // Grab the current centered point, which all new points will stem from
    let center = selection.selectAll('.point').data()[0]
      , scale = { // Scale functions that will always position a node at this previously center location
        x: () => this.previous.scalers.x.groupScale.range()[1] / 2, // Always center
        y: () => this.previous.yScale(center._range[1])
      }
      , self = this
      , startCoords = {
        x: scale.x(),
        y0: this.previous.yScale(center._range[0]),
        y1: scale.y()
      }

    this._points(merged, scale, scale) // So the points are in the DOM and properly bound

    // Build the points object we can use to transition the path as we move the actual point locations
    let points = this.scalers.x.groupScale.domain().reduce((p, c) => {
      p[c] = {}
      return p
    }, {})

    merged.selectAll('.point')
          .tween('move', function (d) {
            let interpolateX = interpolate(startCoords.x, self.scalers.x.center(d.rangeId))
              , interpolateY0 = interpolate(startCoords.y0, self.yScale(d._range[0]))
              , interpolateY1 = interpolate(startCoords.y1, self.yScale(d._range[1]))

            return self._tweenPoint(this, points, interpolateX, interpolateY0, interpolateY1)
          })
          .end().then(() => {
            // Done transitioning, properly bind the data

            // Update the points...
            this._points(selection)

            // Then the paths
            this._rebindPaths(selection, serie.points)
        })
  }

}

export default AddBreakdownAnimation
